import React from 'react';
import { ToastContainer, toast, Flip } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import { firebase } from '../../firebase';
import { addCourses } from '../../store/actions/cartActions';
import { fetchCourses } from '../../methods/api-calls';
import { connect } from 'react-redux';

class Login extends React.Component {
  state = {
    email: '',
    password: '',
    redirectNow: false,
  };

  async componentDidMount() {
    const { courses } = this.props;
    if (!courses || (courses && courses.length == 0)) {
      const newCourses = await fetchCourses();
      this.props.addCourses(newCourses);
    }
  }

  handleSignInWithEmail = e => {
    e.preventDefault();
    firebase
      .auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(() => {
        toast.success('Has iniciado sesión', {
          position: 'bottom-left',
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => {
          this.setState({
            redirectNow: true,
          });
        }, 1500);
      })
      .catch(function (error) {
        toast.error(error.message, {
          position: 'bottom-left',
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(error);
      });
  };
  render() {
    if (this.state.redirectNow) {
      return <Redirect to="/admin/dashboard" />;
    }
    return (
      <div className="admin-signin ptb-100">
        <div className="d-table">
          <div className="d-table-cell">
            <ToastContainer transition={Flip} />

            <div className="container">
              <div className="login-content">
                <h2>Admin Login</h2>

                <form onSubmit={this.handleSignInWithEmail} className="login-form">
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={this.state.email}
                      onChange={e => this.setState({ email: e.target.value })}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Contraseña"
                      value={this.state.password}
                      onChange={e => this.setState({ password: e.target.value })}
                    />
                  </div>

                  <button type="submit" className="default-btn">
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    courses: state.courses,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCourses: courses => {
      dispatch(addCourses(courses));
    },
  };
};
const WrappedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);
export { WrappedLogin as Login };
